import React from 'react';
import { Signup } from './components/Signup';
import { Login } from './components/Login';
import ChitList from './components/ChitList';
import Nav from './components/Nav';
import About from './components/About';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ChitDetail from './components/ChitDetail';
import { AuthProvider } from './contexts/Auth';
import { PrivateRoute } from './components/PrivateRoute';
import ChitForm from './components/ChitForm';
import AuctionForm from './components/AuctionForm';
import CompletedChitsList from './components/CompletedChitsList';
import { useTranslation } from 'react-i18next';
import Settings from './components/Settings';

const lngs = {
  en: { nativeName: 'English' },
  tn: { nativeName: 'தமிழ்' }
};

export default function App() {
  const { i18n } = useTranslation();

  return (
    <Router>
      <div className="App">
        <AuthProvider>
          <Nav languages={lngs} i18n={i18n} />
          <Switch>
            <PrivateRoute exact path="/" component={ChitList} />
            <Route path="/signup" component={Signup} />
            <Route path="/login" component={Login} />
            <Route path="/about" component={About} />
            <PrivateRoute exact path="/chit/:chitId" component={ChitDetail} />
            <PrivateRoute exact path="/add" component={ChitForm} />
            <PrivateRoute exact path="/chit/:chitId/auction/add" component={AuctionForm} />
            <PrivateRoute exact path="/chit/:chitId/edit" component={ChitForm} />
            <PrivateRoute exact path="/chit/:chitId/auction/:auctionId/edit" component={AuctionForm} />
            <PrivateRoute exact path="/completed" component={CompletedChitsList} />
            <PrivateRoute exact path="/user" component={Settings} />
          </Switch>
        </AuthProvider>
      </div >
    </Router >
  );
}
